import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "react-hot-toast";

import AdminContainer from "../AdminContainer/AdminContainer";
import PublicContainer from "../PublicContainer/PublicContainer";
import AuthContainer from "../AuthContainer/AuthContainer";
import NotFoundPage from "./../../pages/Page/NotFoundPage/NotFoundPage";
import PreLoader from "../../helpers/PreLoader/PreLoader";
import { decodeJWT, getCookies } from "../../utils";
import { setUserAction } from "../../redux/actions/userActions/userActions";
import {
  clearAuthAction,
  setAuthAction,
} from "../../redux/actions/authActions/authActions";
import { setThemeAction } from "../../redux/actions/themeActions/themeActions";
import { setMetaAction } from "../../redux/actions/metaActions/metaActions";

const App = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const loader = useSelector((state) => state.loader);
  const theme = useSelector((state) => state.theme);

  const accessToken = getCookies("accessToken");

  useEffect(() => {
    if (accessToken) {
      const decodedToken = decodeJWT(accessToken);
      const dateNow = Date.now() / 1000;
      if (decodedToken?.exp < dateNow) dispatch(clearAuthAction());
      else {
        dispatch(setAuthAction(accessToken));
      }
    }
  });

  useEffect(() => {
    if (accessToken) {
      dispatch(setUserAction());
      dispatch(setMetaAction());
    }
  }, [accessToken]);

  useEffect(() => {
    dispatch(setThemeAction({ skin: localStorage.getItem("skin") || "light" }));
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  return (
    <>
      {loader && <PreLoader />}

      {/* RHT Component */}
      <Toaster
        toastOptions={{
          position: "top-left",
          style: theme.isDarkMode ? { background: "#333", color: "#fff" } : {},
        }}
      />
      <Routes>
        {/* Admin Container */}
        <Route path="/admin/*" element={<AdminContainer />} />
        {/* Auth Container */}
        <Route path="/auth/*" element={<AuthContainer />} />
        {/* Public Container */}
        <Route path="/*" element={<PublicContainer />} />
        {/* Not Found */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
};

export default App;
